const WALLET = {
    LOADING:"WALLET_LOADING",
    FETCH_SUCCESS:"WALLET_FETCH_SUCCESS",
    FETCH_FAILED:"WALLET_FETCH_FAILED"
};

export {
    WALLET
};